export function startTimer() {
  return new Date().getTime()
}

export function stopTimer(startTime) {
  return new Date().getTime() - startTime + 'ms'
}
